import { SidebarTab } from '@process-advisor/process-miner/shared/consts';

export const TabsTitles = {
    [SidebarTab.variantsTab]: 'Slicer',
    [SidebarTab.filtersTab]: 'Filters',
    [SidebarTab.discoveryTab]: 'Discovery',
    [SidebarTab.modelTab]: 'Model',
    [SidebarTab.settingsTab]: 'Settings',
};

